exports = module.exports = require("../../node_modules/_css-loader@2.1.1@css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".report-page[data-v-00552a90]{background-color:#f9f9f9;position:relative;overflow-y:scroll;padding:0 20px;padding-top:20px;min-width:800px}.report-area[data-v-00552a90]{padding:20px 0;background-color:#ffffff}\n", ""]);

